import { useCallback } from 'react'
import { useSummaryById } from '@renderer/chat/hooks'
import { useSummaryContext } from './use-summary-context'
import { useDebouncedSave } from './use-debounced-save'

export function useSummaryTaskDelete(
  edited: string | undefined,
  setEdited: (edited: string | undefined) => void,
  onSaveEdits: (updated?: string) => Promise<void>,
) {
  const { summary } = useSummaryContext()
  const { data: fullSummary } = useSummaryById(summary.id)
  const { debouncedSave, isSaving } = useDebouncedSave(async (content: string) => {
    await onSaveEdits(content)
  })

  const onDeleteListItem = useCallback(
    (item: any) => {
      const lineNumber = item?.lineNumber
      if (lineNumber === undefined) return

      const currentMd = edited ?? (fullSummary?.summary || '')
      const lines = currentMd.split('\n')

      // Line numbers from markdown are 1-indexed, convert to 0-indexed array
      const targetLineIndex = lineNumber - 1

      // Validate the line index is within bounds
      if (targetLineIndex < 0 || targetLineIndex >= lines.length) return

      const targetLine = lines[targetLineIndex]

      // Verify this line is actually a task
      if (!/^\s*(?:[*+-]|\d+[.)])?\s*\[[xX ]\]/.test(targetLine)) return

      // Remove the line
      lines.splice(targetLineIndex, 1)
      const newMd = lines.join('\n')

      setEdited(newMd)
      debouncedSave(newMd)
    },
    [edited, fullSummary?.summary, setEdited, debouncedSave],
  )

  return { onDeleteListItem, isSaving }
}
